import { render, staticRenderFns } from "./TZero.vue?vue&type=template&id=55865b77&scoped=true&"
import script from "./TZero.vue?vue&type=script&lang=js&"
export * from "./TZero.vue?vue&type=script&lang=js&"
import style0 from "./TZero.vue?vue&type=style&index=0&id=55865b77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55865b77",
  null
  
)

export default component.exports